import { 
    GET_DELIVERY_INFO_DATA, 
    GET_DELIVERY_INFO_DATA_ERROR, 
    GET_DELIVERY_INFO_DATA_SUCCESS,
} from "../actions/parcelDeliveryAction";

const initialState = {
    parcelDeliveryData: {},
    loading: false,

    data: {},
    saving: false,
    error: null,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_DELIVERY_INFO_DATA:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case GET_DELIVERY_INFO_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                parcelDeliveryData: action.payload.success,
            };
        case GET_DELIVERY_INFO_DATA_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                parcelDeliveryData: [],
            };

        default:
            return state;
    }
}
